import { ApiService } from '@/api/services/core/ApiService';
import ENDPOINTS from '@/api/endpoints';
import { TaxPayersQueryParams } from '@/api/services/types';
import { axiosInstance } from '@/api/axios';
import { ReceiptDetails, Taxes, Taxpayer } from '@/store/types';

export class SelfEmployeeService extends ApiService {
  public getTaxpayersList(params: TaxPayersQueryParams) {
    return axiosInstance.get<any>(ENDPOINTS.taxPayers.index, {
      params: { ...params, taxMode: 'ESP' },
    });
  }

  public getTaxpayerProfile(id: string | number) {
    return axiosInstance.get<Taxpayer>(ENDPOINTS.taxPayers.id(id));
  }

  public getTaxpayerDetails({ id, year }: { id: string; year: string }) {
    return axiosInstance.get<any>(
      ENDPOINTS.taxPayers.idDetailsYear({ id, year }),
    );
  }

  public getTaxpayerIncome(
    id: string,
    params: { type: string; month: string },
  ) {
    return axiosInstance.get<any>(ENDPOINTS.receipts.income.id(id), {
      params,
    });
  }

  public getTaxDetails(id: string, year: string) {
    return axiosInstance.get<Taxes>(ENDPOINTS.taxPayers.idTaxDetails(id), {
      params: { year },
    });
  }

  public getPartnersList(params: TaxPayersQueryParams) {
    return axiosInstance.get<any>(ENDPOINTS.partners.index, {
      params,
    });
  }

  public getPartners({ id, year, ...params }: Record<string, any>) {
    return axiosInstance.get<any>(
      ENDPOINTS.partners.idDetailsYear({ id, year }),
      { params },
    );
  }

  public getPartnersIncome(
    id: string,
    params: { type: string; period: string },
  ) {
    return axiosInstance.get<any>(ENDPOINTS.partners.idDetailsIncomeYear(id), {
      params,
    });
  }

  public getReceipts(
    id: string,
    params: { type: string; startDate: string; endDate: string },
  ) {
    return axiosInstance.get<any>(ENDPOINTS.receipts.income.id(id), {
      params,
    });
  }

  public getReceiptDetails(id: number) {
    return axiosInstance.get<ReceiptDetails>(ENDPOINTS.receipts.id(id));
  }

  public getSummaryStatistics(taxNo: string, params: { period?: string }) {
    return axiosInstance.get<any>(ENDPOINTS.taxPayers.idTaxHistory(taxNo), {
      params: { ...params },
    });
  }
}

